(function () {
var $0d1866656773842e$var$selectors = {
    benefits: '.benefits--compact',
    benefitItem: '.benefit',
    benefitTooltip: '.tooltip',
    benefitIcon: '.benefit__icon'
};
// Only load logo logos when they are in the user's field of vision.
var $0d1866656773842e$var$benefitsObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        var benefitContainer = entry.target;
        if (entry.isIntersecting) {
            benefitContainer.querySelectorAll($0d1866656773842e$var$selectors.benefitIcon).forEach(function(icon) {
                var maskImage = icon.getAttribute('data-mask-img');
                if (maskImage) {
                    var _icon_closest;
                    icon.style.setProperty('--mask-img-url', "url(".concat(maskImage, ")"));
                    (_icon_closest = icon.closest($0d1866656773842e$var$selectors.benefitItem)) === null || _icon_closest === void 0 ? void 0 : _icon_closest.setAttribute('data-loaded', 'true');
                }
            });
            observer.unobserve(benefitContainer);
        }
    });
});
var $0d1866656773842e$var$benefitContainers = document.querySelectorAll($0d1866656773842e$var$selectors.benefits);
if ($0d1866656773842e$var$benefitContainers.length) {
    $0d1866656773842e$var$benefitContainers.forEach(function(container) {
        container.querySelectorAll($0d1866656773842e$var$selectors.benefitItem).forEach(function(benefit) {
            var _window_bindTooltip, _window;
            (_window_bindTooltip = (_window = window).bindTooltip) === null || _window_bindTooltip === void 0 ? void 0 : _window_bindTooltip.call(_window, benefit, benefit.querySelector($0d1866656773842e$var$selectors.benefitTooltip));
        });
    });
    $0d1866656773842e$var$benefitContainers.forEach(function(element) {
        return $0d1866656773842e$var$benefitsObserver.observe(element);
    });
}

})();
//# sourceMappingURL=benefit.min.js.map
